
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.945 15.992c.446 0 .696-.32.696-.805v-2.273h.875c1.804 0 3.023-1.234 3.023-3.11V3.032C17.54 1.148 16.32.04 14.516.04h-10.5C2.14.04.992 1.156.992 3.031v6.774c0 1.867 1.149 3.11 3.024 3.11h5.21l2.82 2.577c.368.344.587.5.9.5z","fill":"#AAB4C0"}})])
          )
        }
      }
    